exports = module.exports = require("./../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-button{padding:0 15px 15px}.page-button-group,.page-button-group>*{margin-bottom:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-33792b69!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-markdown-loader/_cache/button-1.vue
// module id = 215
// module chunks = 0